var exports = {
  "lm": "ThreadComposerArea.module__notice___U00teG",
  "EP": "ThreadComposerArea.module__noticeIcon___U00teG",
  "ut": "ThreadComposerArea.module__noticeText___U00teG",
  "Sx": "ThreadComposerArea.module__lockedIcon___U00teG",
};

module.exports = exports;
